import { Store } from 'utils';
import { Creators } from 'model';

var timer = null;

class GiveawayStore extends Store {

	getInitialState() {
		return {
			giveaways: [],
			selected: null,
			prize: null,
			loading: false,
			thankYou: false,
			error: false,
			standId: null
		};
	}

	isLoading() {
		return this.getState().loading == true;
	}

	isThankYou() {
		return this.getState().thankYou == true;
	}

	isError() {
		return this.getState().error == true;
	}

	onPavilionsChanged(state, data) {
		state.giveaways = data.giveaways;
	}

	onGiveawaySelected(state, data) {
		state.selected = data.selected;
	}

	onGiveawayStatusChanged(state, data) {
		Object.assign(state, data);
	}

	onPrizeChanged(state, data) {
		state.prize = data.prize;
		state.standId = data.standId;
	}

	onAboutChanged(state) {
		this.resetStore(state);
	}

	onJobsChanged(state) {
		this.resetStore(state);
	}

	onChatRoomChanged(state, data) {
		if(data.stand) {
			this.resetStore(state);
		}
	}

	onWhyDataChanged(state) {
		this.resetStore(state);
	}

	onGalleryChanged(state) {
		this.resetStore(state);
	}

	resetStore(state) {
		state.selected = this.findNextGiveaway();
		state.loading = false;
		state.thankYou = false;
		state.error = false;

		clearTimeout(timer);
		timer = setTimeout(Creators.giveawaySelected, 10000);
	}

	getGiveaways() {
		return this.getState().giveaways;
	}

	getSelected() {
		return this.getState().selected
	}

	getPrize() {
		return this.getState().prize;
	}

	getStandId() {
		return this.getState().standId;
	}

	findNextGiveaway() {
		const giveaways = this.getGiveaways();
		const chance = 0.5; // Change this value for different percentage
		if (Math.random() < chance && giveaways.length > 0) {
			const next = Math.floor(Math.random() * giveaways.length);
			return giveaways[next];
		}
		return null;
	}
}

const store = new GiveawayStore();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/giveawaystore.js